import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Page,Crud } from '../../components'
import { Descriptions, Badge,Image } from 'antd';
const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class Frui_basedataPage extends Component {
  static propTypes = {
    furui: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
  }

  render() {
    return (
      <Page inner>
      
      <Descriptions  bordered>
    <Descriptions.Item label="编号">IAGSW3205</Descriptions.Item>
    <Descriptions.Item label="单位名称">张家港哲露公司</Descriptions.Item>
    <Descriptions.Item label="所在省份">张家港</Descriptions.Item>
    <Descriptions.Item label="所在市">苏州</Descriptions.Item>
    <Descriptions.Item label="所在区县">
      张家港
    </Descriptions.Item>
    <Descriptions.Item label="电话" >
      18888888888
    </Descriptions.Item>
      <Descriptions.Item label="单位地址" span={3}>
      江苏省苏州市张家港市沙洲湖科技创业园
    </Descriptions.Item>
       <Descriptions.Item label="网址" span={2}>
      www.bnaidu.com
    </Descriptions.Item>
       <Descriptions.Item label="邮箱编码" span={2}>
      215600
    </Descriptions.Item>
    <Descriptions.Item label="公司福利">
      全勤奖
      <br />
     五险一金
      <br />
      加班福利
      <br />
       饭补
      <br />
      带薪休假
      <br />
    </Descriptions.Item>
        <Descriptions.Item label="公司营业执照">
        <img width={200}
      height={200} src='https://qyznoss.oss-cn-hangzhou.aliyuncs.com/2021062416231889727.png?Expires=1644392709&OSSAccessKeyId=LTAIzko9W17qtx0R&Signature=yvYmx443%2Bc4ZvNzSSSXmsvSEdSM%3D' />
    </Descriptions.Item>
  </Descriptions>
  
      </Page>
      
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    furui: state.furui,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Frui_basedataPage);


// WEBPACK FOOTER //
// ./src/features/furui/Frui_basedataPage.js